angular.module('leanlaw').directive('llInfo', ['$compile', '$http', function ($compile) {
  return {
    restrict: 'EA',
    replace: true,
    controller: 'llInfoCtrl',
    scope: {
      image: '=',
      message: '=?'
    },
    link(scope, element, attrs) {
      scope.placement = attrs.placement || 'top';
      scope.tooltip = scope.message || element.html();
      let html = `<span class='fa fa-question-circle ll-info' uib-popover-html='tooltip' popover-placement='${scope.placement}' popover-trigger='mouseenter'></span>`;
      if (attrs.color) {
        html = `<span class='fa fa-question-circle ll-info' uib-popover-html='tooltip' popover-placement='${scope.placement}' popover-trigger='mouseenter' style='color: #${attrs.color}' !important;'></span>`;
      }
      if (attrs.image) {
        html = `<a style="color: #555;" href ng-click="showImage('${attrs.image}')">${html}</span></a>`;
      }
      element.html($compile(html)(scope));
    }
  };
}]).controller('llInfoCtrl', llInfoCtrl);
llInfoCtrl.$inject = ['$scope'];
function llInfoCtrl($scope) {
  $scope.showImage = function (image) {
    const options = {
      src: image,
      width: 1000
    };
    bootbox.alert(`<img src="${options.src}" width="${options.width}"/>`, result => {});
  };
}